import React, { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import 'react-dates/initialize';
import { DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { useTranslation } from 'react-i18next';
import ConfigContext from '../../contexts/ConfigContext';
import { semiExtraSmall } from '../Typography/Typography';

const Wrapper = styled.div`
  position: relative;
  input {
    cursor: pointer;
  }

  .CalendarDay__default {
    border: none;
    ${semiExtraSmall}
  }

  .CalendarDay__today {
    background-color: ${({ theme }) => theme.colors.secondary}1f;
  }

  .CalendarDay__blocked_calendar {
    background-color: ${({ theme }) => theme.colors.surface};
    text-decoration: line-through;
    opacity: 0.4;
  }

  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background-color: ${({ theme }) => theme.colors.primaryDark};
    color: ${({ theme }) => theme.colors.surface};
    font-weight: bold;
    opacity: 1;
    text-decoration: none;
  }

  .CalendarDay__selected_span {
    background-color: ${({ theme }) => theme.colors.primary}D0;
    color: ${({ theme }) => theme.colors.surface};
    text-decoration: none;
    opacity: 1;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      td {
        pointer-events: none;
      }
    `}
`;

const DateRangePicker = ({ startDate, endDate, onChange, isDayBlocked, disabled, className }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState('startDate');
  const { isRtl } = useContext(ConfigContext);

  return (
    <Wrapper className={className} disabled={disabled}>
      <DayPickerRangeController
        startDate={startDate}
        endDate={endDate}
        focusedInput={focus}
        onFocusChange={(value) => setFocus(value ?? 'startDate')}
        onDatesChange={({ startDate, endDate }) =>
          onChange({ startDate, endDate: focus === 'endDate' ? endDate : startDate })
        }
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        isRTL={isRtl}
        renderWeekHeaderElement={(day) => t(day.toLowerCase())}
        isDayBlocked={(day) => isDayBlocked?.(day, focus) || (focus === 'endDate' && day.isBefore(startDate))}
      />
    </Wrapper>
  );
};

export default DateRangePicker;
